import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed right-4 bottom-4 z-50"
}
const _hoisted_2 = { class: "flex items-center gap-3 rounded-full bg-default px-4 py-3 shadow-xl ring-1 ring-default" }

import { domMax, LazyMotion, MotionConfig } from 'motion-v'


export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const route = useRoute()
const monsterClicks = useState('mm:monster-clicks', () => 0)
const colorMode = useColorMode()

const pageForcesDark = computed(() => route.name === 'games-cult-of-the-lamb')
const effectiveDark = computed(() => pageForcesDark.value || colorMode.value === 'dark')
const isAdminRoute = computed(() => route.path === '/admin' || route.path.startsWith('/admin/'))

if (import.meta.client) {
  let observer: MutationObserver | undefined
  let pendingFrame: number | undefined
  let stopRouteWatch: (() => void) | undefined

  function resetAdminStudioOffset() {
    if (!isAdminRoute.value)
      return

    document.body.removeAttribute('data-expand-sidebar')
    document.body.style.removeProperty('margin-left')

    for (const el of document.querySelectorAll<HTMLElement>('[style*="left"]')) {
      const inlineLeft = el.style.left.trim()
      if (!inlineLeft || inlineLeft === '0' || inlineLeft === '0px')
        continue
      if (getComputedStyle(el).position === 'fixed')
        el.style.left = ''
    }
  }

  function queueResetAdminStudioOffset() {
    if (pendingFrame != null)
      cancelAnimationFrame(pendingFrame)

    pendingFrame = requestAnimationFrame(() => {
      pendingFrame = undefined
      resetAdminStudioOffset()
    })
  }

  function startAdminStudioOffsetWatcher() {
    if (observer)
      return

    observer = new MutationObserver(queueResetAdminStudioOffset)
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-expand-sidebar', 'data-studio-active', 'style'],
    })
    queueResetAdminStudioOffset()
  }

  function stopAdminStudioOffsetWatcher() {
    observer?.disconnect()
    observer = undefined
    if (pendingFrame != null) {
      cancelAnimationFrame(pendingFrame)
      pendingFrame = undefined
    }
  }

  // Nuxt Studio can apply its sidebar offset after the admin route has
  // mounted, so only observe body mutations while admin pages are active.
  onMounted(() => {
    stopRouteWatch = watch(isAdminRoute, (admin) => {
      if (admin)
        startAdminStudioOffsetWatcher()
      else
        stopAdminStudioOffsetWatcher()
    }, { immediate: true, flush: 'post' })
  })

  onBeforeUnmount(() => {
    stopRouteWatch?.()
    stopAdminStudioOffsetWatcher()
  })
}

const shellClasses = computed(() => {
  const c: string[] = []
  if (monsterClicks.value === 6)
    c.push('shake', 'shake-constant')
  if (pageForcesDark.value)
    c.push('dark')
  return c
})

useHead({
  bodyAttrs: {
    style: computed(() => `background-color: ${pageForcesDark.value ? 'var(--color-monster-950)' : 'var(--ui-bg)'}`),
    class: computed(() => isAdminRoute.value ? 'is-admin' : ''),
  },
  meta: [
    {
      name: 'theme-color',
      content: computed(() => effectiveDark.value ? '#1a0f0d' : '#fdfaf6'),
    },
  ],
})

return (_ctx: any,_cache: any) => {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_LazyTheMonster = _resolveComponent("LazyTheMonster")!
  const _component_MCloudsTop = _resolveComponent("MCloudsTop")!
  const _component_NuxtPage = _resolveComponent("NuxtPage")!
  const _component_NuxtLayout = _resolveComponent("NuxtLayout")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_LazySkewNotification = _resolveComponent("LazySkewNotification")!
  const _component_UApp = _resolveComponent("UApp")!

  return (_openBlock(), _createBlock(_unref(LazyMotion), { features: _unref(domMax) }, {
    default: _withCtx(() => [
      _createVNode(_unref(MotionConfig), { "reduced-motion": "user" }, {
        default: _withCtx(() => [
          _createVNode(_component_UApp, { toaster: { position: 'top-right', duration: 4000 } }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex flex-col min-h-screen", _unref(shellClasses)])
              }, [
                (!_unref(isAdminRoute))
                  ? (_openBlock(), _createBlock(_component_TheHeader, {
                      key: 0,
                      absolute: ""
                    }))
                  : _createCommentVNode("", true),
                (!_unref(isAdminRoute))
                  ? (_openBlock(), _createBlock(_component_LazyTheMonster, { key: 1 }))
                  : _createCommentVNode("", true),
                (!_unref(isAdminRoute))
                  ? (_openBlock(), _createBlock(_component_MCloudsTop, {
                      key: 2,
                      class: "relative z-[11] h-0 [&::after]:!hidden"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_NuxtLayout, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_NuxtPage, { class: "pb-15" })
                  ]),
                  _: 1
                }),
                (_unref(isAdminRoute))
                  ? (_openBlock(), _createBlock(_component_LazySkewNotification, { key: 3 }, {
                      default: _withCtx(({ isCurrentChunksOutdated, dismiss, reload }) => [
                        _createVNode(_Transition, {
                          "enter-active-class": "transition duration-300 ease-out",
                          "enter-from-class": "opacity-0 translate-y-2",
                          "enter-to-class": "opacity-100 translate-y-0",
                          "leave-active-class": "transition duration-200 ease-in",
                          "leave-from-class": "opacity-100 translate-y-0",
                          "leave-to-class": "opacity-0 translate-y-2"
                        }, {
                          default: _withCtx(() => [
                            isCurrentChunksOutdated
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_UIcon, {
                                      name: "i-lucide-refresh-cw",
                                      class: "size-4 text-primary",
                                      "aria-hidden": "true"
                                    }),
                                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-sm font-bold text-highlighted" }, " Update available ", -1)),
                                    _createVNode(_component_UButton, {
                                      color: "primary",
                                      size: "xs",
                                      label: "Refresh",
                                      onClick: reload
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_UButton, {
                                      color: "neutral",
                                      variant: "ghost",
                                      size: "xs",
                                      icon: "i-lucide-x",
                                      "aria-label": "Dismiss update",
                                      onClick: dismiss
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["features"]))
}
}

})